import { laboratoryClient } from '../utils/laboratoryClient';
import { useEffect, useState } from 'react';
import { EBX632_TREATMENT_KEY, EBX632_GROUP_PARAMETER_OPTIONS, EBX632_GROUP_PARAMETER_KEY, PARAMETERS } from '../constants/experimentKeys'; // EBX-632: Modal in the interstitial

export const useIsEBX632Variant = () => {
  const [isEbx632Variant, setIsEbx632Variant] = useState();
  useEffect(() => {
    laboratoryClient.resolve(treatments => {
      if (Object.keys(treatments).length) {
        const optionValue = treatments[EBX632_TREATMENT_KEY][PARAMETERS][EBX632_GROUP_PARAMETER_KEY];
        setIsEbx632Variant(optionValue === EBX632_GROUP_PARAMETER_OPTIONS.variation);
      }
    });
  }, [isEbx632Variant]);
  return isEbx632Variant;
};